import { PRODUCT_DESCRIPTION_MAX_LENGTH } from '@entities/product/api/product.contract'
import { productNameLengthMessage, validateProductName } from './product-name'

export function productNameRequiredMessage() {
  return 'Informe o nome do produto.'
}

export function productDescriptionRequiredMessage() {
  return 'Informe a descrição do produto.'
}

export function productNameSpacingMessage() {
  return 'Não use espaços consecutivos no nome do produto.'
}

export function productDescriptionSpacingMessage() {
  return 'Não use espaços consecutivos na descrição do produto.'
}

export function normalizeProductText(value: string) {
  return value.replace(/\u200B/g, '').trim()
}

function hasExcessiveConsecutiveSpacing(value: string) {
  return /[\s\u200B]{2,}/u.test(value)
}

export function validateProductBasicDetails(input: {
  name: string
  description: string
}): Partial<Record<'name' | 'description', string>> {
  const errors: Partial<Record<'name' | 'description', string>> = {}

  if (!normalizeProductText(input.name)) {
    errors.name = productNameRequiredMessage()
  } else if (hasExcessiveConsecutiveSpacing(input.name)) {
    errors.name = productNameSpacingMessage()
  } else if (validateProductName(input.name)) {
    errors.name = productNameLengthMessage
  }

  if (!normalizeProductText(input.description)) {
    errors.description = productDescriptionRequiredMessage()
  } else if (hasExcessiveConsecutiveSpacing(input.description)) {
    errors.description = productDescriptionSpacingMessage()
  } else if (input.description.length > PRODUCT_DESCRIPTION_MAX_LENGTH) {
    errors.description = `Use no máximo ${PRODUCT_DESCRIPTION_MAX_LENGTH} caracteres na descrição do produto.`
  }

  return errors
}
